import { Card } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';
import CardContainer from 'src/components/common/CardContainer';
import PMNavBar from './PMNavBar';
import { Switch } from 'react-router-dom';
import RoutePrivate from 'src/components/router/RoutePrivate';
import LeaseRecordingsPage from './LeaseRecordingsPage';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from 'src/reducers';
import { push } from 'connected-react-router';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import AssignmentsPage from './AssignmentsPage';
import TransmittalsPage from './TransmittalsPage';

const ProcessingAndMaintenance = () => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const authContext = useSelector((state: IRootState) => state.auth);
    const isLoggedIn = authContext?.user?.loggedIn;

    const dispatch = useDispatch();
    
    const [location, setLocation] = useState<Location>(undefined);
    const [match, setMatch] = useState<string>('');

    useEffect(() => {
        setLocation(window.location);
        setMatch(window.location.pathname);
    }, []);

    const navigate = (path: string) => {
        dispatch(push(path));
    };

    return (
        <>
            <RHFLegend title={`Processing & Maintenance for ${appContext.clientNumber}.${appContext.projectNumber}`} />
            <CardContainer>
                <Card elevation={1} className="lh-no-padding-card">
                    {location && (
                        <PMNavBar
                            matchUrl={match}
                            location={location.pathname}
                            navigate={navigate}
                        />
                    )}
                    <Switch>
                        <RoutePrivate
                            key="assignments"
                            path={
                                match + '/assignments'
                            }
                            component={AssignmentsPage}
                            isLoggedIn={isLoggedIn}
                        />
                        <RoutePrivate
                            key="transmittals"
                            path={
                                match + '/transmittals'
                            }
                            component={TransmittalsPage}
                            isLoggedIn={isLoggedIn}
                        />
                        <RoutePrivate
                            key="lease-recordings"
                            path={
                                match + '/'
                            }
                            component={LeaseRecordingsPage}
                            isLoggedIn={isLoggedIn}
                        />
                    </Switch>
                </Card>
            </CardContainer>
        </>
    );
};

export default ProcessingAndMaintenance;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/ProcessingAndMaintenance.tsx